import React from 'react';
import { ThumbnailImageProps } from '../ThumbnailImage/ThumbnailImage';
import { Carousel } from '@jbhi-fi/lanyard-ui/components/Carousel';
import { StackedThumbnailImage } from '../ThumbnailImage/StackedThumbnailImage';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { PossiblyResponsiveValue, useResponsiveValue } from '../hooks/useResponsiveValue';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import { CarouselProps } from '@jbhi-fi/lanyard-ui/components/Carousel/Carousel';

export type ThumbnailImageCarouselProps = {
  thumbnails: Array<ThumbnailImageProps>;
  isStacked?: PossiblyResponsiveValue<boolean>;
  carouselProps?: Partial<CarouselProps>;
};

export const ThumbnailImageCarousel = ({
  thumbnails,
  isStacked: isStackedProp = { xs: true, md: false },
  carouselProps = {},
}: ThumbnailImageCarouselProps) => {
  const isStacked = useResponsiveValue(isStackedProp);
  const groupedThumbnails = thumbnails.reduce((acc, thumbnailProps, i) => {
    if (i % 2 === 0) {
      acc.push([thumbnailProps]);
    } else {
      acc[acc.length - 1].push(thumbnailProps);
    }
    return acc;
  }, [] as Array<Array<ThumbnailImageProps>>);

  const isDesktop = useBreakpoint('md', 'up');

  return (
    <Carousel
      slidesPerView="auto"
      showPagination={false}
      showArrows={isDesktop}
      spaceBetween={0}
      slidesOffsetBefore={-8}
      slidesPerGroup={isDesktop ? 2 : 1}
      fullBleed={!isDesktop}
      hideGradients={!isDesktop}
      gradientColor={palette.secondary.main}
      {...carouselProps}
    >
      {groupedThumbnails.map((thumbnails, i) => (
        <StackedThumbnailImage key={i} thumbnails={thumbnails} isStacked={isStacked} />
      ))}
    </Carousel>
  );
};
